export default "__VITE_ASSET__BAjgHrml__"